import { createFileRoute } from "@tanstack/react-router";
import ChemigationSystems from "@/components/field/setup/ChemigationSystems";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/chemigation-systems",
)({
    component: ChemigationSystemsPane,
});

function ChemigationSystemsPane() {
    return <ChemigationSystems />;
}
